/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:13:44
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ይክፈቱ",
    name2: "ቀጠሮ ይያዙ",
    name3: "በ Carlcare አማካኝነት ትዕዛዝዎን በማንኛውም ጊዜ ማረጋገጥ ይችላሉ ፡፡",
    name4: "",
    name5: "ወደ ቀኝ ያንሸራቱ",
    name6: "ማረጋገጥ ተጠናቋል",
  },
  order: {
    name1: "የመሳሪያ ሞዴል ይምረጡ",
    name2: "የስህተት ገለጻ፡",
    name3: "የአገልግሎት መደብርን ለመምረጥ ነካ ያድርጉ",
    name4: "የአገልግሎት መደብር፡",
    name5: "የቀጠሮ ጊዜ፡",
    name6: "እባክዎ የመሣሪያዎን ችግር በዝርዝር ይግለጹ!",
    name7: "የመድረሻ ጊዜን ለመምረጥ ነካ ያድርጉ",
    name8: "እኛ ልንደርስዎ እንድንችል እባክዎን ትክክለኛውን የአድራሻ ዝርዝሮችዎን ያስገቡ",
    name9: "የሚገኝ የቦታ ማስያዝ ጊዜ እንደሚከተለው ነው",
    name10: "እባክዎ ስልክ ቁጥሮን ያስገቡ",
    name11: "ዋጋ",
    name12: "የግላዊ መረጃ፡",
    name13: "እባክዎ ስሞን ያስገቡ",
    name14: "ያስገቡ",
    name15: "ሰርዝ",
    name16: "እሺ",
  },
  shops: {
    name1: "በየሚመርጡት ብራንድ መሰረት፣ የሚከተሉት መደብሮች ሊያገለግሎት ይችላሉ!",
    name2: "ተጨማሪ የሽያጭ መደብሮችን እየከፈትን ነው! ከእኛ ጋር ይሁኑ!",
  },
  price: {
    name1: "ብራንድ",
    name2: "ሞዴል",
    name3: "አይነት",
    name4: "ዋጋ",
    name5: "ወዳጃዊ አስታዋሽ:",
    name6: "እነዚህ ዋጋዎች ለማጣቀሻ ብቻ ናቸው፣ እና ትክክለኛው ዋጋ ለእርስዎ መሣሪያ ሁኔታ ተገዢ ነው።",
    name7: "ልዩ ምልክት ከሌለ፣ የዋጋው ክፍል የአከባቢው ምንዛሬ ክፍል ነው።",
    name8: "ይቅርታ! አሁን ባለው ክልል ውስጥ የዋጋ መረጃ አይገኝም ፡፡",
    name11:"የጉልበት ዋጋ",
    name12:"አጠቃላይ ዋጋ",
    name13: "5. የሠራተኛ ዋጋ \"/\" ከሆነ፣ ይህ ማለት የሠራተኛ ዋጋ ከሱቁ ጋር መማከር አለበት ማለት ነው.",
    item_main_board: "ዋና ሰሌዳ",
    item_screen_frame: "ስክሪን (ፍሬም)",
    item_screen_screen_frame: "ሁለተኛ ስክሪን (ፍሬም)",
    item_touch_screen: "የንክኪ ስክሪን",
    item_camera: "ካሜራ",
    item_fixed_focus_camera: "ቋሚ ማስተካከያ ሌንስ የሌለው ካሜራ",
    item_auto_focus_camera: "ራስ ሰር ማስተካከያ ሌንስ ያለው ካሜራ",
    item_screen: "ስክሪን",
    item_secondary_screen: "ሁለተኛ ስክሪን",
    item_fingerprint_module: "የጣት አሻራ ሞዱል",
    item_speaker: "ድምጽ ማጉያ",
    item_receiver: "ተቀባይ",
    item_small_board: "ትንሽ ሰሌዳ",
    item_battery_cover: "የባትሪ ሽፋን",
    item_battery: "ባትሪ",
    item_charger: "ሃይል መሙያ",
    item_usb_cable: "USB ኬብል",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ውሂብ የለም",
    name2: "የአገልግሎት አቅራቢ፡",
    name3: "የአገልግሎት ብራንድ፡",
    name4: "ቴሌፎን፡",
    name5: "የትእዛዝ መጠን፡",
    name6: "የአገልግሎት ምዘና",
    name7: "የአገልግሎት አካባቢ፡",
    name8: "የአገልግሎት ባህሪ፡",
    name9: "የአገልግሎት ቅልጥፍና፡",
    name10: "የአገልግሎት ጥራት፡",
    name11: "የደንበኞች ግምገማ",
    name12:"ለ",
    name13:"ተዘግቷል",
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ይክፈቱ",
    name1: "ቅድሚያ የሚሰጠውን አገልግሎት ለመድረስ እባክዎን የተያዙ ቦታ መረጃውን በቅጽበታዊ ገጽ እይታ ይመልከቱ እና እንደ ደረሰኝ ያስቀምጡ ፡፡",
    name2: "በተሳካ ሁኔታ ገብቷል",
    name3: "1. መረጃን ማጽዳት",
    name4: "እባክዎን በስልክዎ ላይ አስፈላጊ የግል መረጃዎችን አስቀድመው ያስቀምጡ",
    name5: "2. ኃይል-አብራ ን የይለፍ ቃልን እንዳይሰራ ያድርጉ",
    name6: "ወደ ሱቅ አገልግሎት ከመሄድዎ በፊት ፣ እባክዎን፥",
    name7: "የአገልግሎት መደብር፡",
    name8: "የቀጠሮ ጊዜ፡",
    name9: "የስህተት ገለጻ፡",
    name10: "የመሳሪያ ሞዴል፡",
    name11: "የትእዛዝ ቁጥር:",
    name12: "የትዕዛዝ መረጃ",
  },
  title: {
    name1: "የሚከተሉትን ሀገሮች ይደግፋል፥",
    name2: "ሞዴል ይምረጡ",
    name3: "ቦታ ማስያዣ",
    name4: "የአገልግሎት  መደብር ዝርዝሮች",
    name5: "የአገልግሎት መደብርን ይምረጡ",
  },
  error: {
    name1: "ሰነድ የለም፥ እባክዎ የጥገና መረጃዎን ያረጋግጡ",
    name2: "ተጨማሪ እርዳታ ይፈልጋሉ? እባክዎ ያግኙን፡፡",
    name3: "ይቅርታ ፣ አሁን ባለው ክልል ውስጥ የ Carlcare ማዕከል የለም ፡፡",
    name4: "እባክዎን በመጀመሪያ የአገልግሎት ማእከልን ይምረጡ",
    name5: "አልተሳካም",
    name6: "እባክዎን መጀመሪያ የመሣሪያውን ሞዴል መርጠዋል",
    name7: "ዝርዝሮች",
    name8: "እባክዎን ፍላጎቶችዎን በዝርዝር ይግለጹ",
    name9: "",
  },
  add1:{
    "name0": "am-rET",
    "name1": "የእርሶ ትህዛዝ ተረጋግጧል። መምጣቶን በጉጉት እንጠባበቃለን።",
    "name2": "ከተማ ይምረጡ",
    "name3": "እባኮን %1$s አሃዞች የስልክ ቁጥር ያስገቡ።",
    "name4": "የሳምንቱ ቀን ሰዓቶች",
    "name5": "ሰኞ",
    "name6": "ማክሰኞ",
    "name7": "ረቡዕ",
    "name8": "ሐሙስ",
    "name9": "ዓርብ",
    "name10": "ቅዳሜ",
    "name11": "እሁድ",
    "name12": "ሃገር ያስገቡና ይፈልጉ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "ሌሎች",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  "name58": "ነጻ የስልክ ማፅዳት/ ነፃ የሶፍትዌር መጫን",
  coupons: {
    name1:"Coupons",
    name2:"አቅጣጫ ለመቀየር ነካ ያድርጉ",
    name3:"ለትዕዛዙ ደረጃ ለመስጠት የ Carlcare መተግበሪያን ይክፈቱ",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"አገልግሎት ይምረጡ",
    name7:"ነጻ ጽዳት",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "የተሳሳተ መረጃ",
    "cancelReason1": "በሰዓቱ መድረስ አልተቻለም",
    "cancelReason2": "የተባዛ ትዕዛዝ / የእኔ ትዕዛዝ አይደለም",
    "cancelReason3": "ውድቀት አይደገምም",
    "cancelReason4": "ለሙከራ/ለመጠየቅ/ለክስተት/…",
    "cancelReason5": "ከፍተኛ ዋጋ",
    "cancelReason6": "የዕቃ እጥረት",
    "cancelReason7": "ምንም ልዩ አገልግሎቶች የሉም",
    "cancelReason8": "መደብሩ በጣም ሩቅ ነው",
    "cancelReason9": "መደብሩ ተዘግቷል",
    "cancelReason10": "መጥፎ የአገልግሎት አመለካከት",
    "cancelReason11": "ለሌሎች ብራንዶች ምትክ/ጥገና",
    "cancelReason12": "መደብሩን ማግኘት አልተቻለም",
    "cancelReason13": "ሌላ",
    "cancelOrder": "ትዕዛዝን ይሰርዙ",
    "reason_dialog_title": "እባክዎን የመሰረዞን ምክንያት ይንገሩን",
    "Cancel": "ተሰርዟል",
    "OK": "እሺ",
    "name1": "የማረጋገጫ ኮድ ያስገቡ",
"name2": "ልክ ያልሆነ የማረጋገጫ ኮድ",
"repair_reservation_detail_canceled": "ይህ ትእዛዝ ተሰርዟል!",
"purchase_cancel_dialog_content": "ትዕዛዙ መሰረዙን አረጋግጠዋል?",
"yes": "አዎ ",
"no": "አይደለም"
},
onSiteService:{
  "name1": "የመደብር ውስጥ ጥገና",
    "name2": "የጣቢያ ላይ አገልግሎት",
    "name3": "የጣቢያ አገልግሎቱን ለመጠቀም መገኛን ማብራት ያስፈልግዎታል። እባክዎን ያብሩት እና እንደገና ይሞክሩ።",
    "name4": "እባኮት ቦታዎን ይምረጡ:",
    "name5": "የአካባቢ ትእዛዞች",
    "name6": "የአሁን መገኛ:",
    "name7": "አድራሻ:",
    "name8": "ስም",
    "name9": "ቴሌፎን፡"
}
};
